import { LockResetIcon } from './LockResetIcon';

/**
 * author: Google
 * id 82312B48-E128-494E-9D84-DAACB41986F4
 * name lock-reset
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-reset.svg
 * tags
 * - Lock 
 */
export const PasswordResetIcon = LockResetIcon;
export default PasswordResetIcon